import { render, staticRenderFns } from "./ManualGrantPoints.vue?vue&type=template&id=222c87fc&scoped=true"
import script from "./ManualGrantPoints.vue?vue&type=script&lang=js"
export * from "./ManualGrantPoints.vue?vue&type=script&lang=js"
import style0 from "./ManualGrantPoints.vue?vue&type=style&index=0&id=222c87fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c87fc",
  null
  
)

export default component.exports